export default __webpack_public_path__ + "static/media/toxina-botulinica.b775ef0b.png";